import View from '../../../Core/View.js';

export default class InfoBox extends View {
	initialize(options) {
		this.map = options.map;
		this.infowindow = new google.maps.InfoWindow();

		google.maps.event.addListener(this.infowindow, 'domready', this._onInfoDomReady.bind(this));
		this.map.addListener('zoom_changed', this._onZoomChange.bind(this));
	}

	update(point, marker) {
		const description = point.description ? point.description : '';
		const htmlTemplate = `
            <div class="info-box">
                <h1 class="info-box__title">${point.headTitle}</h1>
                <div id="info-box__content-holder">
                    <p class="info-box__content-holder__content">${description}</p>
                </div>
            </div>
            <div class="info-box__arrow-box">
                <div class="info-box__arrow"></div>
            </div>`;

		this.infowindow.setContent(htmlTemplate);
		this.infowindow.open(this.map, marker);
	}

	_onInfoDomReady() {
		const start = this.el.querySelector('.gm-style-iw');

		const button = start.nextElementSibling;
		button.className = 'info-box__content-holder__close-button';
		button.removeChild(button.childNodes[0]);

		const previous = start.previousElementSibling;
		previous.parentNode.removeChild(previous);
	}

	_onZoomChange() {
		this.infowindow.close();
	}
}


// WEBPACK FOOTER //
// ./js/Views/Modules/LocationMap/InfoBox.js